function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOffice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      strokeWidth: 1.56862748
    },
    d: "M12.549 1.569A3.913 3.913 0 0 0 8.627 5.49v70.588A3.913 3.913 0 0 0 12.55 80h54.902a3.913 3.913 0 0 0 3.922-3.922v-50.98l-21.57-1.96-1.96-21.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.549 0a3.913 3.913 0 0 0-3.922 3.922V74.51a3.913 3.913 0 0 0 3.922 3.921h54.902a3.913 3.913 0 0 0 3.922-3.921V23.53l-21.57-1.961L47.844 0Z",
    style: {
      fill: "#c03630",
      strokeWidth: 1.56862748
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#fff",
      strokeWidth: 1.56862748
    },
    d: "M12.549 0a3.913 3.913 0 0 0-3.922 3.922V5.49a3.913 3.913 0 0 1 3.923-3.92h35.294V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.03 66.948a75.696 75.696 0 0 0-3.059-1.104 350.032 350.032 0 0 0-7.664-2.776 15.518 15.518 0 0 0-1.04-.378 151.33 151.33 0 0 0-3.313-1.199 1372.687 1372.687 0 0 0-7.064-2.586c-.726-.253-.757-.253.756-.063a622.096 622.096 0 0 0 10.598 1.45 59.61 59.61 0 0 1 2.902.41 90.993 90.993 0 0 1 2.838.38 965.473 965.473 0 0 1 5.299.693c.063 0 .063-30.752 0-30.783l-.757.126a142.151 142.151 0 0 1-5.709 1.23 29.27 29.27 0 0 1-1.64.315 1251.888 1251.888 0 0 1-6.497 1.42l-.284.063v21.226l-.22.095a138.776 138.776 0 0 0-4.385 1.64 187.411 187.411 0 0 1-3.785 1.42V33.104l.442-.158a85.158 85.158 0 0 1 3.659-1.324 124.079 124.079 0 0 0 3.847-1.388 929.738 929.738 0 0 0 11.986-4.353 155.682 155.682 0 0 0 3.154-1.167.63.63 0 0 1 .441 0 315.243 315.243 0 0 1 7.38 1.861 1798.51 1798.51 0 0 1 4.952 1.199l.127.031v36.082l-6.371 1.577-6.372 1.577-.22-.063z",
    style: {
      fill: "#000",
      fillOpacity: 0.26666667,
      strokeWidth: 0.04978474
    },
    transform: "translate(1.871 .665) scale(.95321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.03 65.37a75.696 75.696 0 0 0-3.059-1.105 350.032 350.032 0 0 0-7.664-2.775 15.518 15.518 0 0 0-1.04-.379 151.33 151.33 0 0 0-3.313-1.198 1372.687 1372.687 0 0 0-7.064-2.587c-.726-.252-.757-.252.756-.063a622.096 622.096 0 0 0 10.598 1.451 59.61 59.61 0 0 1 2.902.41 90.993 90.993 0 0 1 2.838.379 965.473 965.473 0 0 1 5.299.694c.063 0 .063-30.752 0-30.784l-.757.127a142.151 142.151 0 0 1-5.709 1.23 29.27 29.27 0 0 1-1.64.315 1251.888 1251.888 0 0 1-6.497 1.42l-.284.062v21.227l-.22.095a138.776 138.776 0 0 0-4.385 1.64 187.411 187.411 0 0 1-3.785 1.419V31.527l.442-.158a85.158 85.158 0 0 1 3.659-1.325 124.079 124.079 0 0 0 3.847-1.388 929.738 929.738 0 0 0 11.986-4.352 155.682 155.682 0 0 0 3.154-1.167.63.63 0 0 1 .441 0 315.243 315.243 0 0 1 7.38 1.86 1798.51 1798.51 0 0 1 4.952 1.2l.127.03V62.31l-6.371 1.577-6.372 1.577-.22-.063z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      strokeWidth: 0.04978474
    },
    transform: "translate(1.871 .665) scale(.95321)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      strokeWidth: 1.56862748
    },
    d: "M47.843 1.569v19.607a3.921 3.921 0 0 0 3.922 3.922h19.608Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.843 0v19.608a3.921 3.921 0 0 0 3.922 3.921h19.608Z",
    style: {
      fill: "#f36961",
      strokeWidth: 1.56862748
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffice);
export default __webpack_public_path__ + "static/media/office.e5ca950d7e908ae19f21fcf84cd78274.svg";
export { ForwardRef as ReactComponent };